/**
 *
 *
 * Usage:
 *
 *   data-sw-input-image-preview="<previe target selector>"
 */

var $ = require('js/sw-jquery/sw-jquery');

module.exports = function($fragment) {

  $fragment.swFindWithSelf('[data-sw-input-image-preview]').each(function() {
    var $el = $(this);
    var data = $el.swDataParams('swInputImagePreview');
    var previewTargetSelector = data.swInputImagePreview;

    $el.on('change', function () {

      if (this.files && this.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
          $(previewTargetSelector).css('background-image', 'url(' + e.target.result + ')');
        };

        reader.readAsDataURL(this.files[0]);
      }
    });
  });

};
